import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var _dec, _class;

import { injectable } from 'inversify';
import 'reflect-metadata';
/**
 * Layer Model 初始化，更新，销毁
 */

var LayerModelPlugin = (_dec = injectable(), _dec(_class = /*#__PURE__*/function () {
  function LayerModelPlugin() {
    _classCallCheck(this, LayerModelPlugin);
  }

  _createClass(LayerModelPlugin, [{
    key: "initLayerModel",
    value: function initLayerModel(layer) {
      // 更新Model 配置项
      layer.prepareBuildModel(); // 初始化 Model

      layer.buildModels();
      layer.styleNeedUpdate = false;
    }
  }, {
    key: "prepareLayerModel",
    value: function prepareLayerModel(layer) {
      var _layer$layerModel;

      // 更新Model 配置项
      layer.prepareBuildModel(); // clear layerModel resource

      (_layer$layerModel = layer.layerModel) === null || _layer$layerModel === void 0 ? void 0 : _layer$layerModel.clearModels(); // 初始化 Model

      layer.buildModels();
      layer.layerModelNeedUpdate = false;
    }
  }, {
    key: "apply",
    value: function apply(layer) {
      var _this = this;

      layer.hooks.init.tap('LayerModelPlugin', function () {
        layer.inited = true;
        layer.modelLoaded = false;
        var source = layer.getSource();

        if (source.inited) {
          _this.initLayerModel(layer);
        }
      });
      layer.hooks.beforeRenderData.tap('DataSourcePlugin', function () {
        var source = layer.getSource();
        layer.modelLoaded = false;

        if (source.inited) {
          _this.prepareLayerModel(layer);
        } else {
          source.once('update', function () {
            _this.prepareLayerModel(layer);
          });
        }

        return false;
      });
    }
  }]);

  return LayerModelPlugin;
}()) || _class);
export { LayerModelPlugin as default };